import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Equipement} from 'app/models/equipement.model';
import {PieceEquipement} from '../../../../models/pieceEquipement.model';
import {Piece} from '../../../../models/piece.model';
import {EquipementService} from '../../../../services/equipement.service';
import {User} from '../../../../models/user.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {UserService} from '../../../../services/user.service';
import {FicheIntervention} from '../../../../models/ficheIntervention.model';
import {forEach, map} from 'lodash-es';
import {PhotoLieu} from '../../../../models/photoLieu.model';
import {FicheInterventionService} from '../../../../services/fiche-intervention.service';
import {PhotoService} from '../../../../services/photo.service';

@Component({
    selector: 'app-modal-photo',
    templateUrl: './modal-photo.component.html',
    styleUrls: ['./modal-photo.component.scss']
})
export class ModalPhotoComponent implements OnInit {
    @Input() dossierInterventionId: number;
    @Input() pieces: Piece[] = [];


    success: boolean = false;
    error: boolean = false;

    photosToBeUploaded: object[] = [];

    photoBeingUploaded: string[] = [];
    photoDoneUploading: string[] = [];

    form: FormGroup;

    constructor(
        private photoService: PhotoService,
        public dialogRef: MatDialogRef<ModalPhotoComponent>,
    ) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            photos: new FormControl(null),
            piece_id: new FormControl(null, [Validators.required]),
            dossier_intervention_id: new FormControl(this.dossierInterventionId, [Validators.required]),
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;

        const uploadTime = Date.now();

        Promise.all(map(this.photosToBeUploaded, (file: any, i) => new Promise((resolve) => {

            const photo = new PhotoLieu({
                file: file,
                piece_id: this.form.value.piece_id,
                dossier_intervention_id: this.dossierInterventionId,
                name: uploadTime + '-' + i.toString().padStart(4, '0') + '-' + (file?.file ?? Date.now())
            });

            this.photoService.store(photo).subscribe(
                (response) => {
                    this.photoDoneUploading.push(file.name);
                    resolve(true);
                }, (error) => {
                    this.error = true;
                }
            );
        }))).then(() => {
            this.success = true;
            this.dialogRef.close();
        });
    }

    addFiles(event): void {
        if (event.target.files) {
            forEach(event.target.files, (file, i): void => {
                const reader = new FileReader();

                reader.onload = (e: any): void => {
                    this.photosToBeUploaded.push({url: e.target.result, file: event.target.files[i]['name']});
                };

                reader.readAsDataURL(event.target.files[i]);
            });
        }
    }
}
